import { connect } from 'react-redux';

import FolderDropTarget from '../../../components/DriveItemList/FolderDropTarget';

export default connect()(FolderDropTarget);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/FolderDropTarget/index.tsx